<template>
  <div style="position: static!important;">
    <HeaderBackMobile :noCart="true" />
    <b-container fluid class="container_chat_general">
      <div class="message_container" style="overflow-y:scroll;overflow-x:hidden;width:vw;padding:0;">
        <b-row>
          <b-col>
            <template v-for="(message, idxm) in messages">
              <b-row :align-h="'center'" v-if="message.automaticType === true"  v-bind:key="idxm" style="margin:10px 0;">
                <b-col cols="10" class="chat_balloom_automatic" v-html="message.htmlBody">
                </b-col>
              </b-row>
              <b-row v-else-if="message.author.indexOf('@') === -1" :align-h="'end'" v-bind:key="idxm" style="margin:10px 0;">
                <b-col cols="8" class="chat_balloom" v-html="message.htmlBody">
                </b-col>
              </b-row>
              <b-row v-else   v-bind:key="idxm" style="margin:10px 0;">
                <b-col cols="8" class="chat_balloom_customer" v-html="message.htmlBody">
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
      </div>
      <b-row class="chat_form" align-v="center" :style="{backgroundColor:getCssColor('primary_bt')}" >
        <b-col style="height:42px;">
          <input type="text"
            class="chatInput"
            style="width:calc(100% - 42px);float:left;"
            id="input1"
            v-model="chatMessage"
            placeholder="Digite uma mensagem" 
            @keypress.enter="sendMessageToChannel()"
            onblur="window.scrollTop=0;document.scrollTop=0;document.body.scrollTop=0;"
            />
          <font-awesome-icon @click="sendMessageToChannel()" style="margin:6px 0 0 12px;;float:right;" class="chatAction" :icon="['fal', 'paper-plane']"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>


import ChatConn from '@/connection/chat'
import HeaderBackMobile from '@/components/HeaderBackMobile'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'


export default {

  data () {
    return {
      chatMessage: null,
      showProductUnder: false,
      showToast: false,
      toastStatus: 'success',
      toastMessage: 'sucesso',
      channel: null,
      messages: [],
      scrollInterval: null,
      shopperId: null
    }
  },

  components: {HeaderBackMobile},
  mixins: [colors, formaters],

  async created () {
    this.$store.state.showLoading = true
    this.shopperId = this.$route.params.shopperId
    let initialized = await ChatConn.initChat()
    console.log('initialized', initialized)
    let joinned = await ChatConn.joinToChannel(this.$route.params.channelName)
    console.log('joinned', joinned)
    let channels = await ChatConn.listChannels()
    console.log('channels', channels)
    
    this.channel = await ChatConn.getChannelByName(this.$route.params.channelName)
    this.channel.on('messageAdded', this.updateMessages)
    this.messagesIterator = await this.channel.getMessages()
    this.messages = this.parseMessagesBody(this.messagesIterator.items)
    console.log(this.messages)
    this.$store.state.showLoading = false
  },

  async mounted () {
    this.autoScroll()
  },

  destroyed() {
    if (this.channel) {
      this.channel.removeListener('messageAdded', this.updateMessages)
    }
    clearInterval(this.scrollInterval, this.scrollToBottom)
    this.scrollInterval = null
  },

  methods: {

    autoScroll () {
      clearInterval(this.scrollInterval, this.scrollToBottom)
      this.scrollInterval = null
      this.scrollInterval = setTimeout(this.scrollToBottom, 500)
    },

    scrollToBottom () {
      if (document) {
        let messageContainer = document.querySelector('.message_container')
        if (messageContainer) {
          messageContainer.scrollTop = messageContainer.scrollHeight + 10000
        }
      }
    },

    async sendMessageToChannel () {
      if (this.chatMessage) {
        await ChatConn.sendMessageToChannel(this.channel, this.chatMessage, this.shopperId)
        this.chatMessage = null
        window.scrollTop=0;document.scrollTop=0;document.body.scrollTop=0;
      }
    },

    updateMessages (m) {
      this.messages.push(this.parseMessage(m))
      this.autoScroll()
    },

    parseMessagesBody (messages) {
      let parsedMessages  = []
      messages.forEach((m) => {
        parsedMessages.push(this.parseMessage(m))
      })
      return parsedMessages
    },

    parseMessage (m) {
      console.log('message attributes', m.attributes)
      m.htmlBody = m.body
      m.automaticType = false

      // messages of suggestion
      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_OFFER_'){
        m.automaticType = true
        m.htmlBody = 'Deseja incluir <b>' + (m.attributes.message_add_info.productQtt || 1 ) + '</b> unidade(s) de <b>' +
          m.attributes.message_add_info.productName + '</b>, por <b>R$ ' + this.formatPrice(m.attributes.message_add_info.productPrice) + '</b> a unidade, à sua lista de compras?<br/><br/>'+
          '<img src="' + m.attributes.message_add_info.productImage + '" style="max-height:100px;margin:5px; auto;"/><br><br/>' +
          '<button class="info_buttom" onClick="window.yesnoadd(\'yes\', \''+ 
            m.attributes.message_add_info.purchaseNumber +'\', \'' +
            m.attributes.message_add_info.productId + '\', \'' +
            m.attributes.message_add_info.productViewId + '\', \'' +
            m.attributes.message_add_info.productPrice + '\', \'' +
            m.attributes.message_add_info.productName +'\', \''+ 
            m.sid +'\', \''+ 
            this.shopperId +'\')">Sim</button> '+
          '<button class="danger_buttom" onClick="window.yesnoadd(\'no\', \'' +
            m.attributes.message_add_info.purchaseNumber +'\', \'' +
            m.attributes.message_add_info.productId + '\', \'' +
            m.attributes.message_add_info.productViewId + '\', \'' +
            m.attributes.message_add_info.productPrice + '\', \'' +
            m.attributes.message_add_info.productName +'\', \''+ 
            m.sid + '\', \''+ this.shopperId +'\')">Não</button><br/>'
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_ACCEPT_'){
        m.automaticType = true
         m.htmlBody = 'Você ACEITOU a sugestão de <b>' + m.attributes.message_add_info.productName + '</b> e foi incluso na lista.'
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_REJECT_'){
        m.automaticType = true
         m.htmlBody = 'Você REJEITOU a sugestão de <b>' + m.attributes.message_add_info.productName + '</b>'
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_CHANGE_QTT_'){
         m.htmlBody = 'A quantidade do produto <b>' + m.attributes.message_add_info.productName + '</b> foi alterada de '+
          m.attributes.message_add_info.oldQtt + ' para ' + m.attributes.message_add_info.newQtt
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_CHANGE_PRICE_'){
         m.htmlBody = 'O preço do produto <b>' + m.attributes.message_add_info.productName + '</b> foi alterado de '+
          'R$ ' + this.formatPrice(m.attributes.message_add_info.oldPrice) + ' para R$ ' + this.formatPrice(m.attributes.message_add_info.newPrice)
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_CHANGE_TOTAL_'){
        m.automaticType = true
         m.htmlBody = 'O total da compra foi alterado para '+
          'R$ ' + this.formatPrice(m.attributes.message_add_info.newTotal)
      }

      if (m.attributes && m.attributes.message_type && m.attributes.message_type === '_REMOVE_'){
         m.htmlBody = 'O produto <b>' + m.attributes.message_add_info.productName + '</b> foi removido da lista de compras '
      }

      return m
    },

  }
}
</script>

<style lang="scss">
@import "@/css/_colors.scss";
.info_buttom {
  background-color: $primary;
  width:80px;
  height:36px;
  border-radius:4px;
  border:1px solid #ffffff;
  color:$light;
  font-size:16px;
  font-weight:500;
  margin-right:8px;
  margin-bottom:16px;
}

.danger_buttom {
  background-color: $danger;
  width:80px;
  height:36px;
  border-radius:4px;
  border:1px solid #ffffff;
  color:$light;
  font-size:16px;
  font-weight:500;
  margin-left:8px;
}
</style>

<style lang="scss" scoped>


@import "@/css/_colors.scss";

.container_chat_general {
  background-color:#FAFAFA;
  height:calc(100vh - 70px);
  width:100%;
  max-width:1024px;
  @supports (-webkit-overflow-scrolling: touch) {
    /* CSS specific to iOS devices */ 
    //height:calc(100vh - 370px);
  }
}

.message_container {
  height:calc(100% - 70px);
  @supports (-webkit-overflow-scrolling: touch) {
    /* CSS specific to iOS devices */ 
    //height:calc(100vh - 470px);
  }
}

.chatInput {
  border: 1px solid $light;
  height:42px;
  padding:5px;
  border-radius:4px;
}

.chat_balloom {
  background-color:$primary-light-2;
  color:$dark;
  border-radius:10px 20px 0 10px;
  padding:10px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
}

.chat_balloom_customer {
  background-color:$light;
  color:$dark;
  border-radius:0 10px 10px 20px;
  padding:10px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
}

.chat_balloom_automatic {
  background-color:$info;
  color:$dark-light-2;
  border-radius:10px;
  padding:10px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  text-align:center;
}

.chat_form {
  height:70px;
  bottom:0px;
}

.chatAction {
  font-size:28px;
  color: $light;
}

.pop_under {
  color: $light;
  background-color:$dark-light-2;
  height: 100vh;
  width: 100vw;
  left:0vw;
  top:0vh;
  -webkit-transition: top 0.2s linear;
  -moz-transition: top 0.2s linear;
  -ms-transition: top 0.2s linear;
  -o-transition: top 0.2s linear;
  transition: top 0.2s linear;
}

.pop_under_openned {
  color: $light;
  background-color:$dark-light-2;
  height: 100vh;
  width:100vw;
  left:0vw;
  top:100vh;
  -webkit-transition: top 0.2s linear;
  -moz-transition: top 0.2s linear;
  -ms-transition: top 0.2s linear;
  -o-transition: top 0.2s linear;
  transition: top 0.2s linear;
}

</style>
